import { useEffect, useState, useContext } from "react"
import { CustomButton } from "../../components/global/CustomButton"
import { useParams } from "react-router-dom"
import { ProductsContext } from "../../contexts/ProductsContext"
import { UserContext } from "../../contexts/UserContext"
import { NotificationRender } from "../../components/global/NotificationRender"
import "./adminProduct.css"

export function AdminProduct() {
    const categories = ["Add New...", "Men's clothing", "Women's clothing", "Jewlery", "Electronics"]

    const [pageTitle, setPageTitle] = useState("Add Product")
    const [btnText, setBtnText] = useState("Add Product")

    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [category, setCategory] = useState(categories[0].toLowerCase())
    const [categoryDisabled, setCategoryDisabled] = useState(false)
    const [newCategory, setNewCategory] = useState("")
    const [regularPrice, setRegularPrice] = useState("")
    const [salePrice, setSalePrice] = useState("")
    const [stock, setStock] = useState("")
    const [image, setImage] = useState("")

    const { id } = useParams()

    const productsDataContext = useContext(ProductsContext)
    const { products, dispatch, notification } = productsDataContext

    const userContextData = useContext(UserContext)
    const { token } = userContextData

    const [product, setProduct] = useState(null)

    useEffect(() => {
        if(id && products) {
            const thisProduct = products.find(e => e._id === id)
            setProduct(thisProduct)
        }
    }, [id, products])

    useEffect(() => {
        if(product) {
            setPageTitle("Edit Product")
            setName(product.title)
            setDescription(product.description)
            setCategory(product.category)
            setRegularPrice(product.regularPrice)
            setSalePrice(product.salePrice)
            setStock(product.stock)
            setImage(product.image)
            setBtnText("Update Product")            
        }
    }, [product])

    useEffect(() => {
        if (category !== categories[0].toLowerCase()) {
            setCategoryDisabled(true)
        } else {
            setCategoryDisabled(false)
        }
    }, [category])

    const handleFile = async (e) => {
        const file = e.target.files[0]
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            const result = fileReader.result
            setImage(result)
        }
    }

    /* async function createFile(imagePath){
        let response = await fetch(imagePath)
        let data = await response.blob()

        const fileReader = new FileReader()
        fileReader.readAsDataURL(data)
        fileReader.onload = async () => {
            const result = fileReader.result

            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/updateProduct`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ _id: id, image: result })
            })
        }
    } */
   
    //${process.env.REACT_APP_API_BASE_URL}
    async function handleAddProduct() {
        //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/addProduct`, {
        const response = await fetch(`http://localhost:3001/api/addProduct`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                title: name, description, category,
                regularPrice, salePrice, stock, image
            })
        })
        const json = await response.json()

        if(response.status === 200) {
            console.log(json)
            dispatch({ type: "ADD_PRODUCT", payload: json.product })
        } else {
            const { error } = json
            dispatch({ type: "PRODUCT_ERROR_ACTION_FORBIDDEN" })
            console.log(json)
        }
    }
    //${process.env.REACT_APP_API_BASE_URL}
    async function handleUpdateProduct() {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/updateProduct`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                productId: id, title: name, description, category,
                regularPrice, salePrice, stock, image
            })
        })
        const json = await response.json()

        if(response.status === 200) {
            console.log(json)
            const filteredProducts = products.filter(a => a._id !== id)
            dispatch({ type: "UPDATE_PRODUCT", payload: [ ...filteredProducts, json.product ] })
        } else {
            const { error } = json
            dispatch({ type: "PRODUCT_ERROR_ACTION_FORBIDDEN" })
            console.log(json)
        }
    }
    //${process.env.REACT_APP_API_BASE_URL}
    async function handleDeleteProduct() {
        const productId = id
        
        const response = await fetch(`http://localhost:3001/api/deleteProduct/${productId}`, {
        /* const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/deleteProduct/${productId}`, { */
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
        })
        const json = await response.json()

        if(response.status === 200) {
            dispatch({ type: "DELETE_PRODUCT", payload: id })
        } else {
            const { error } = json
            dispatch({ type: "PRODUCT_ERROR_ACTION_FORBIDDEN" })
            console.log(json)
        }
    }

    return (
        <div className="add-product">

            {
                notification && notification.type.includes("PRODUCT") &&
                    <NotificationRender notification={notification} />
            }

            <h4>{pageTitle}</h4>

            <div className="d-flex mt-5 add-main md-row">
                <div className="add-product-form d-flex flex-column gap-3 pe-md-3">

                    <div>
                        <div>Product Name</div>
                        <input
                            type="text"
                            className="custom-input"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div>
                        <div>Product Description</div>
                        <textarea
                            rows={7}
                            className="custom-input"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}>
                        </textarea>
                    </div>

                    <div className="d-flex flex-column">
                        <div>Category</div>
                        <div className="d-flex align-items-center gap-2 add-category">
                            <select
                                id="category"
                                className="rounded-1"
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}>
                                {
                                    categories.map((e, i) => (
                                        <option key={i} value={e.toLowerCase()}>{e}</option>
                                    ))
                                }
                            </select>
                            <input
                                type="text"
                                className={"custom-input " + (categoryDisabled ? "off" : "")}
                                value={newCategory}
                                onChange={(e) => setNewCategory(e.target.value)}
                                disabled={categoryDisabled}
                            />
                        </div>

                    </div>

                    <div className="d-flex justify-content-between gap-3">
                        <div className="w-50">
                            <div>Regular Price</div>
                            <input
                                type="text"
                                className="custom-input"
                                value={regularPrice}
                                onChange={(e) => setRegularPrice(e.target.value)}
                            />
                        </div>
                        <div className="w-50">
                            <div>Sale Price</div>
                            <input
                                type="text"
                                className="custom-input"
                                value={salePrice}
                                onChange={(e) => setSalePrice(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-between gap-3">
                        <div className="w-50">
                            <div>Stock</div>
                            <input
                                type="text"
                                className="custom-input"
                                value={stock}
                                onChange={(e) => setStock(e.target.value)}
                            />
                        </div>
                        <div className="w-50">
                        </div>
                    </div>

                </div>

                <div>
                    <div className="product-form-image d-flex cntr border rounded-1 p-3">
                        {
                            image ?
                                <img src={image} alt="" />
                                :
                                <img src="/images/landscape-placeholder.svg" alt="" />
                        }
                    </div>
                    
                    <div className="label">
                        <input
                            type="file"
                            name="file"
                            id="file-input"
                            className="d-none"
                            onChange={handleFile}
                        />
                        <label htmlFor="file-input" className="upload-btn-label w-100">
                            <div className="custom-btn default rounded-1 d-flex cntr gap-5 mt-2">
                                <div className="export-icon"></div>
                                <div>Upload Image</div>
                            </div>
                        </label>
                    </div>

                </div>

            </div>

            <div className="d-flex justify-content-end gap-2 mt-2 btns md-row">
                <div>
                    <CustomButton
                        color="secondary"
                        text={btnText}
                        btnFunction={() => id ? handleUpdateProduct() : handleAddProduct()}
                    />
                </div>
                {
                    id && 
                        <div>
                            <CustomButton
                                color="primary"
                                text="Delete"
                                btnFunction={handleDeleteProduct}
                            />
                        </div>
                }
                <div>
                    <CustomButton
                        color="default"
                        text="Cancel"
                    />
                </div>
            </div>
        </div>
    )
}